export const LocalStorageSymbol = Symbol.for('LocalStorageAdapter');

export interface ILocalStorageAdapter {
    write(key: string, value: string): Promise<any>;
    read(key: string): Promise<any>;
    remove(key: string): Promise<any>;
}
